export const formatMessageTemplate = (
	stringTemplate: string | undefined,
	replacementText: string | undefined
): string | undefined => {
	const replacementToken = '{0}';

	if (!stringTemplate) {
		return undefined;
	}

	if (replacementText) {
		return stringTemplate?.replace(replacementToken, replacementText || '');
	}

	return stringTemplate;
};
